import React from 'react';

import Spinner from './Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject , useNestedObjectSelector, getNestedObject} from '../redux/hooks'



function ThumbProfile(props) {

    const dispatch = useDispatch()
    const objectId = "/api/profiles/" + props.profileId
    const profileSelector = useObjectSelector(objectId)
    const profile = getObject(objectId, profileSelector, dispatch)
    const thumbnailSelector = useNestedObjectSelector(objectId, (profile)=>"/api/images/"+profile.thumbnail)
    const thumbnail = getNestedObject(profile,()=>"/api/images/"+profile().thumbnail, thumbnailSelector, dispatch)


    return (
        <div>
            <figure class="image is-64x64">
                {profile() !== "UNKNOWN" ?
                    <a href={"/profiles/" + profile().id}>
                        <img class="is-rounded" src={thumbnail().source} alt={profile().name} title={profile().name} />
                    </a>
                    :
                    <Spinner />
                }
            </figure>

        </div>
    );
}

export default ThumbProfile;